export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
at({ "en": { "panel": { "title": "Summary Title", "generatingSummary": "Generating deal summary...", "noSummary": "No summary to show" } } });
};